// Math rendering utility using KaTeX — restricted to span.katex

declare global {
  interface Window {
    katex: any;
  }
}

function stripOuterDelimiters(tex: string): string {
  if (!tex) return '';
  let t = tex.trim();
  // Remove common math delimiters if present at the edges
  t = t.replace(/^\s*(\\\(|\\\[|\$\$)/, '');
  t = t.replace(/(\\\)|\\\]|\$\$)\s*$/, '');
  return t.trim();
}

/**
 * Renders ONLY math inside <span class="katex">…</span> elements.
 * Content outside these spans is left untouched.
 */
export function renderMathInHtml(htmlContent: string): string {
  if (!htmlContent) return '';

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  if (typeof window !== 'undefined' && window.katex) {
    const katexSpans = tempDiv.querySelectorAll('span.katex');
    katexSpans.forEach((node) => {
      const el = node as HTMLElement;
      const raw = el.textContent || '';
      const tex = stripOuterDelimiters(raw);
      try {
        window.katex.render(tex, el, {
          displayMode: false,
          throwOnError: false,
        });
      } catch (error) {
        // Leave text as-is on error
        // eslint-disable-next-line no-console
        console.warn('KaTeX render error:', error);
      }
    });
  }

  return tempDiv.innerHTML;
}
